export default "__VITE_ASSET__uJK2zsXo__"